import React from 'react';
import PropTypes from 'prop-types';
import { APP_I18N_INITIALIZED, subscribe } from '@edx/frontend-platform';
import { mergeMessages } from '@edx/frontend-platform/i18n';
import { useContextId } from '@src/data/hooks';

import messages from './i18n';
import CourseOutlineTrigger from './CourseOutlineTrigger';

subscribe(APP_I18N_INITIALIZED, () => {
  mergeMessages(messages);
});

const CourseOutlineSidebarTriggerPlugin = ({
  sectionId, sequenceId, unitId, isStaff, Link,
}) => {
  const courseId = useContextId();
  return (
    <CourseOutlineTrigger
      courseId={courseId}
      sectionId={sectionId}
      sequenceId={sequenceId}
      isStaff={isStaff}
      unitId={unitId}
      Link={Link}
    />
  );
};

CourseOutlineSidebarTriggerPlugin.propTypes = {
  unitId: PropTypes.string.isRequired,
  sequenceId: PropTypes.string.isRequired,
  sectionId: PropTypes.string.isRequired,
  isStaff: PropTypes.bool.isRequired,
  Link: PropTypes.node.isRequired,
};

export default CourseOutlineSidebarTriggerPlugin;
